import React from "react";
import { connect, type ConnectedProps } from "react-redux";
import { GroupTemplateCustomers } from "../../Details/GroupTemplateCustomers";
import { type ModalWithStepsStep } from "components/modal/ModalWithSteps";
import { type AppDispatch, type RootState } from "features/Application/globaltypes/redux";
import { setCustomersToAdd } from "../../state/TemplateAvailableCustomersSlice";
import { modalColumnOptions } from "../../Details/Customers/getColumnOptions";
import { bindAction } from "interfaces";
import { getAvailableCustomers } from "../../state/thunks/TemplateAvailableCustomersThunk";

export interface AddCustomersModalStepProps extends ModalWithStepsStep {
  filter?: object;
  templateId: number;
}

export type AddCustomersModalStepPropsAll = PropsFromRedux & AddCustomersModalStepProps;

export const AddCustomersModalStep: React.FC<AddCustomersModalStepPropsAll> = ({
  selectedIds,
  setSelectedIds,
  items,
  isLoading,
  itemsCount,
  getData,
  templateId,
  isPacksLoading,
}) => {
  return (
    <GroupTemplateCustomers
      getData={getData}
      items={items}
      isLoading={isLoading || isPacksLoading}
      itemsCount={itemsCount}
      templateId={templateId}
      columnOptions={modalColumnOptions}
      selectedIds={selectedIds}
      setSelectedIds={setSelectedIds}
    />
  );
};

/* istanbul ignore next */
const mapStateToProps = (state: RootState) => {
  return {
    isPacksLoading: state.people.groupTemplate.addCustomersPacks.isLoading,
    items: state.people.groupTemplate.availableCustomers.items,
    itemsCount: state.people.groupTemplate.availableCustomers.itemsCount,
    isLoading: state.people.groupTemplate.availableCustomers.isLoading,
    selectedIds: state.people.groupTemplate.availableCustomers.customersToAdd,
  };
};

/* istanbul ignore next */
const mapDispatchToProps = (dispatch: AppDispatch) => ({
  setSelectedIds: (ids: number[]) => dispatch(setCustomersToAdd(ids)),
  getData: bindAction(getAvailableCustomers, dispatch),
});

const connector = connect(mapStateToProps, mapDispatchToProps);
type PropsFromRedux = ConnectedProps<typeof connector>;

const ConnectedComponent = connector(AddCustomersModalStep);
export default ConnectedComponent;
